import script from "./OrderPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderPage.vue?vue&type=script&setup=true&lang=js"

import "./OrderPage.vue?vue&type=style&index=0&id=a1963094&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a1963094"]])

export default __exports__